import logo from './logo.svg';
import './App.css';
import React, { useState, useEffect } from "react";
import images from './images'
import { Link } from "react-router"

import { database } from "./firebaseConfig2";
import Josh from "./components/josh"
import joshwhistle from "./other-assets/joshed.mp3";
import AudioPlayer from "./components/audio-player"
import Photocards from "./components/photocards"
import Adoptable from "./components/adoptable"
import About from './components/about';
import Blog from './components/blog';

import fanlistings from './components/object-lists/fanlistings';
import stamps from './components/object-lists/stamps';
import { collection, doc, setDoc, onSnapshot  } from "firebase/firestore"; 
import Hatchery from './components/hatchery';
import Webring1 from './components/webring1';
import Library from './components/library';
import { useNavigate } from "react-router";


function Home() {
  const [status, setStatus] = useState({
    date: 'Loading...', 
    message: 'Loading...'});

    const [statusList, setStatusList] = useState([]);

    const [josh, setJosh] = useState(false);

    const [main, setMain] = useState(true);
    const [about, setAbout] = useState(false);
    const [hatchery, setHatchery] = useState(false);
    const [blog, setBlog] = useState(false);
    const [library, setLibrary] = useState(false);

    const listFansites = shuffle(fanlistings.map(temp =><a className = "fansite-item" target="_blank" rel="noopener noreferrer" href={temp.url}><img src={temp.thumbnail}/></a> ));
    const listStamps = shuffle(stamps.map(temp =><img src={temp.url}/>));

    let navigate = useNavigate();

    function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
        }
      return array;
    }
    


  useEffect(
    () =>
      onSnapshot(collection(database, "statuses"), (snapshot) => {
        snapshot.forEach((doc) => {
          let tempdate = new Date(doc.data().date).toString();

          if (tempdate == "Invalid Date"){
            tempdate = doc.data().date;
          }
          let tempstatus = {
            date: tempdate,
            message: doc.data().message
          }
          setStatusList(statusList.push(tempstatus));
        });
        setStatus(statusList.at(-1));
      }),
    []
  );

  let whistle = new Audio(joshwhistle);

  const handleJosh = () =>{
    setJosh(true);
    whistle.play();
    
    setTimeout(function() { setJosh(false); }, 3500);
    setTimeout(function() { whistle.pause(); }, 3560);

  }

  const handlePages = (pageName) =>{
    setMain(false);
    setAbout(false);
    setHatchery(false);
    setBlog(false);
    setLibrary(false);

    if (pageName == "about"){
      setAbout(true);
    }
    if (pageName == "main"){
      setMain(true);
    }
    if (pageName == "blog"){
      setBlog(true);
    }
    if (pageName == "hatchery"){
      setHatchery(true);
    }
    if (pageName == "library"){
      setLibrary(true);
    }
  }



  return (
      <div className='site-container'>
          <div className={'page-controller'}>
          <div className= {main ? "main-page-top-wrapper" :  "page-hidden"}>
            <img id="sleepykitty" src={images.sleepykitty.url}></img>
            
            <div className='left-column'>
            <div className = "headshot">
              <div className = "icon">
                  <img id = "binari" src = {images.binari.url}></img>
                  {/* <img id = "frame" src = {frame}></img> */}
              </div>
              <div class = "attr">
                  <a href="https://www.webtoons.com/en/fantasy/the-dark-lords-confession/list?title_no=4464">icon: the dark lord's confession</a>   
              </div>
            </div>

          {/* <!-- TITLE --> */}
          <div className = "title">
              <h1>🍓 marketchipping 🍓</h1>
          </div>

          {/* <!-- LINKS --> */}
          <div className = "links">
            <div className= {josh ?'popupWrapperActive':'popupWrapperHidden'} >
            <Josh josh={josh}/>
          </div>
              <p>links</p>
              <div className = "linkswrapper">
                <div onClick={() => navigate('/about')}> ✮ info </div>
                  <div onClick={() => window.location.href='https://marketchipping.atabook.org/'}>✮ guestbook</div>
                  <div  onClick={() => handleJosh()}>✮ josh</div>
                  <div onClick={() => navigate('/library')}> ✮ library </div>
              </div>
          </div>

          {/* The "GOD FUCKING DAMN IT KRIS" webring */}
        
          <Webring1/>
          
              
          {/* <div className='pagedolls'>
            <img className="pagedolls-img" src={images.bao2.url} alt="baobear"></img>
            <img className="pagedolls-img" src={images.bao.url} alt="baobear"></img>
            </div> */}
          </div>

          <div className="mainmenu">
            <div className="status-wrapper">
            <p id="status-title">status</p>
              <div className = "status">
                <div id = "status-details">{status.date}</div>
                <div className = "status-message" id="actual-homepage-status">
                  <p>{status.message}</p>
                </div>
              </div>
            </div>
            <div id="adopt-positioner">
              <Adoptable handlePages={handlePages}/>
            </div>
            <div className='badges-webrings'>
              <p id="webrings-title">fanlistings</p>
              {/* <p id = "badgedesc">Check in later to see!</p> */}
              <div id='fansites'>
                {listFansites}
              </div>
              <div id="birds">
                {/* <img src={images.birdgif.url}></img> */}

              </div>

            </div>

          </div>

        

          {/* <!-- OTHERS --> */}
          <div className = "other">
            <div id = "other-positioner">
              <img id="strawberrygif1" src={images.strawberrygif.url}></img>
              <div id = "photocards-positioner">
                <Photocards shuffle={shuffle}/>
              </div>
              
              <AudioPlayer/>
              {/* <!-- BADGES / DOODADS --> */}
              <div className = "badges">
                {listStamps}
              </div>
              <img id="strawberrygif2" src={images.strawberrygif.url}></img>
          </div>
          </div>
          </div>
          {/* <Blog blog={blog} handlePages={handlePages}/> */}

</div>
</div>


  );
}

export default Home;
